import { render } from "./MaterialCounter.vue?vue&type=template&id=122ede13&scoped=true"
import script from "./MaterialCounter.vue?vue&type=script&lang=js"
export * from "./MaterialCounter.vue?vue&type=script&lang=js"

import "./MaterialCounter.vue?vue&type=style&index=0&id=122ede13&scoped=true&lang=css"

import exportComponent from "D:\\Program\\Personal\\WebStormProjects\\_SPA\\MaterialCounter\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122ede13"]])

export default __exports__